import type { Action } from 'redux';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { ResetSettingsRequestActionPayload, ResetSettingsResponseActionPayload } from '../AdPartner.types';

const ResetSettings = new ReduxAsyncAction<
  'AD_PARTNER_RESET_SETTINGS',
  ResetSettingsRequestActionPayload,
  ResetSettingsResponseActionPayload
>('AD_PARTNER_RESET_SETTINGS');

ResetSettings.registerRequest(async ({ partner, machine_name }) => {
  const params = partner
    ? {
        params: {
          app_id: partner.app_id,
        },
      }
    : {};

  await dash_api.delete(`/v1/ad-networks/app/${machine_name}`, params);
  const { data: enabledPartners } = await dash_api.get('/v1/ad-networks/app');
  const { data: partnerBlueprint } = await dash_api.get(`/v1/ad-networks/global/${machine_name}`);

  return {
    partnerBlueprint,
    enabledPartners,
  };
});

export const RESET_SETTINGS = ResetSettings.actionNamespaceConstants;

export const resetSettings = ResetSettings.request;

export type ResetSettingsResponseAction = Action<typeof RESET_SETTINGS.response> & {
  data: ResetSettingsResponseActionPayload;
};
